import React, {PureComponent} from "react"
import {Mutation} from "@irati/utils/services/apollo"
import {MutationProps, MutationFn, ApolloQueryResult} from "@irati/utils/apollo"

import {RecognitionFeedComment, Recognition, Poll} from "@irati/types"
import {gql} from "@irati/utils/gql"
import {feedPollQuery} from "../query/FeedPoll"
import {feedRecognitionQuery} from "../query/FeedRecognition"

interface Emoji {
  id: string
  native: string
}

const graphQLMutation = gql`
  mutation addReaction($reaction: RecognitionFeedReactionInput!) {
    addReaction(reaction: $reaction) {
      createdAt
      createdBy {
        uuid
        firstname
        lastname
      }
      reaction
      uuid
    }
  }
`

/* eslint no-undef: 0 */
interface Props extends Partial<MutationProps> {
  recognition?: Recognition
  poll?: Poll
  comment: RecognitionFeedComment
  children: any
}

interface Data {
  data: {
    updateRecognition: Recognition
  }
}

export default class AddReactionMutation extends PureComponent<Props> {
  render() {
    const {children, comment, poll, recognition, ...props} = this.props
    const {query} = recognition ? feedPollQuery.query : feedRecognitionQuery.query

    return (
      <Mutation mutation={graphQLMutation} {...props}>
        {(mutate: MutationFn, apolloState: ApolloQueryResult<Data>) =>
          children((emoji: Emoji) => {
            return mutate({
              variables: {
                reaction: {
                  reaction: emoji.native
                }
              },
              refetchQueries: [
                {
                  query,
                  variables: {
                    id: emoji.id
                  }
                }
              ]
            })
          }, apolloState)
        }
      </Mutation>
    )
  }
}
